import axios from 'axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';

export function addEditorialHomeworkToFavourite(userId, homeworkId) {
    const url = `${API_URL}/favouriteeditorialhomework/users/${userId}/homework/${homeworkId}`;
    return {
        types: [
            types.ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE,
            types.ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_SUCCESS,
            types.ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_FAILURE
        ],
        promise: axios.post(url)
    };
}

export function removeEditorialHomeworkFromFavourite(userId, homeworkId) {
    const url = `${API_URL}/favouriteeditorialhomework/users/${userId}/homework/${homeworkId}`;
    return {
        types: [
            types.REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE,
            types.REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_SUCCESS,
            types.REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_FAILURE
        ],
        promise: axios.delete(url)
    };
}

export function getFavouriteEditorialHomework(userId) {
    const url = `${API_URL}/favouriteeditorialhomework/users/${userId}`;
    return {
        types: [types.GET_FAVOURITE_EDITORIAL_HOMEWORK, types.GET_FAVOURITE_EDITORIAL_HOMEWORK_SUCCESS, types.GET_FAVOURITE_EDITORIAL_HOMEWORK_FAILURE],
        promise: axios.get(url)
    };
}
